export const faqData = [
  {
    title: "Dog Sharing",
    subtopics: [
      {
        question: "What even is dog sharing?",
        answer: `Dog sharing is a concept where dog owners share the joy and responsibility of their dog with trusted, vetted individuals in their community. Think of it like a playdate arrangement — your dog gets extra love, walks, and attention from someone who adores dogs but might not be able to own one themselves.`,
      },
      {
        question: "Why dog-share?",
        answer: [
          "Why Pup Pals dog-share:",
          "Our Pup Pals (dog lovers without a full-time dog of their own) join Social Paws for many reasons, including:",
          {
            list: [
              "Exercise: Having a companion for walks, runs, and outdoor adventures.",
              "Companionship: Enjoying the comfort of spending time with a furry friend while working from home or relaxing.",
              "Family dynamics: Giving dog-loving children or family members the opportunity to enjoy dogs without the commitment of ownership.",
              "Missing their dogs: Staying connected to dogs after the loss of a beloved pet, or while living away from family dogs.",
              "Life changes: Finding companionship during retirement, after a move, a divorce, or other major life transitions.",
            ],
          },
          "Why Pup Pawrents dog-share:",
          "Our Pup Pawrents (dog owners) often join Social Paws to:",
          {
            list: [
              "Give their dog more affection, attention, and enrichment.",
              "Provide their dog with additional walks, playtime, and companionship.",
              "Reduce the amount of time their dog spends alone.",
              "Save money on dog care, such as walking, daycare, or boarding.",
              "Enjoy occasional flexibility or a helping hand with dog parenting.",
            ],
          },
        ],
      },
      {
        question:
          "Who pays for the dog’s needs: ie: dog grooming, food, treats, etc?",
        answer: `Pup Pawrents are always responsible for their dog's expenses and overall care, including food, grooming, veterinary care, medications, and other day-to-day needs.

Pup Pals contribute their time, companionship, and care through walks, playdates, adventures, or other agreed-upon activities.

As dog-sharing relationships grow, it's not uncommon for Pup Pals to occasionally spoil their shared dog with a toy or treats—much like an aunt or uncle might. But these gestures are entirely optional.

Ultimately, the Pup Pawrent remains responsible for their dog's expenses and sets the care guidelines that Pup Pals are expected to follow.`,
      },
      {
        question: "Do the dogs enjoy dog-sharing?",
        answer: `Many dogs thrive with dog-sharing. They often benefit from additional attention, affection, enrichment, exercise, and meaningful social interaction.

That said, every dog is different. Some dogs are naturally more social and adaptable than others. We encourage introducing dog-sharing gradually, paying close attention to your dog's comfort, behavior, and enthusiasm throughout the process.

As your dog's Pup Pawrent, you know them best. If your dog appears stressed, uncomfortable, or simply doesn't enjoy dog-sharing, it's okay to slow down, adjust the relationship, or decide it's not the right fit. Their wellbeing always comes first.`,
      },
    ],
  },
  {
    title: "Platform FAQs",
    subtopics: [
      {
        question: "How Does Social Paws Work?",
        answer: `Social Paws helps dog lovers find one another, build trust, and create meaningful dog-sharing relationships.

Using the app, you can discover nearby Pup Pawrents and Pup Pals, explore profiles, exchange messages, schedule walks, and leave reviews after real-life interactions.

Our goal isn't simply to match people - it's to help neighbors build lasting relationships through dogs, whether for occasional walks, playdates, or long-term dog-sharing. Social Paws provides the tools to help you connect safely and intentionally.`,
      },
      {
        question: "What is the Pup-Sharing Journey?",
        answer: `Social Paws is built around the philosophy that: relationships come before responsibility.

We don't expect you to hand your dog off to a complete stranger. Instead, we guide members through a gradual journey that builds trust over time.

Milestone 1: Toss a Treat — Show interest in a dog or fellow dog lover by tossing a Treat. It's a friendly way to say, "I'd like to connect!"

Milestone 2: Take a Group Walk — Meet in person with the dog's Pup Pawrent for a walk together. This is your opportunity to get to know one another, ask questions, and see how everyone connects.

Milestone 3: Take the Leash — When everyone feels comfortable, the member takes the dog on their first solo walk.

Milestone 4: Become a Trusted Pup Pal — When a Pup Pawrent designates someone as a Trusted Pup Pal, they're saying, "I trust you with my dog." Trusted Pup Pals can view the dog's availability calendar and instantly book available walks.

Progressing through the journey is always mutual. Both parties must agree before moving to the next milestone, and either person can choose to remain at their current milestone or end the journey at any time.`,
      },
    ],
  },
  {
    title: "Safety FAQs",
    subtopics: [
      {
        question: "Is dog-sharing safe?",
        answer: `Safety is our top priority, but like any new relationship, dog-sharing requires good judgment and trust.

Social Paws is designed to help neighbors build trust gradually - not rush into sharing responsibility. Members are encouraged to get to know one another through conversations, group walks, and solo walks before becoming Trusted Pup Pals.

We support safer connections through complete member profiles, detailed Pup Playbooks, Reviews, Reporting tools, and secure sign-in with Google or Apple.

Every member also plays an important role in keeping our community safe. Take time to ask questions, communicate openly, and only move forward when everyone - including the dog - feels comfortable.

The strongest dog-sharing relationships are built on honesty, communication, and trust.`,
      },
      {
        question: "What is the Pup Playbook?",
        answer: `The Pup Playbook is a dog's care guide. It gives anyone spending time with your pup the information they need to provide safe, confident, and consistent care.

Your Pup Playbook may include:

• Daily routines and care instructions
• Feeding schedule and dietary needs
• Medications and medical conditions
• Veterinary contact information
• Emergency contacts
• Commands your dog knows
• Triggers, fears, and behaviors to be aware of
• Favorite toys, treats, and activities
• Walking preferences and care guidelines

The more complete your Pup Playbook, the more prepared and confident your Trusted Pup Pals will be.`,
      },
      {
        question: "What if an incident or emergency occurs during a dog-share?",
        answer: `If an incident or emergency occurs while you're caring for a shared dog:

• Stay calm and prioritize everyone's safety.
• Contact the dog's Pup Pawrent immediately and explain what happened.
• Decide on the next steps together whenever possible.
• If the Pup Pawrent cannot be reached and veterinary care is needed, use the emergency contact and veterinary information provided in the Pup Playbook.
• If necessary, follow the appropriate procedures for your personal health, property, or pet insurance.

Clear, timely communication is essential. We encourage both parties to keep one another informed throughout the situation and work together in the dog's best interest.`,
      },
    ],
  },
  {
    title: "Team Paws FAQs",
    subtopics: [
      {
        question: "Do I have to meet someone before they care for my dog?",
        answer: `Yes. In fact, it's required.

Social Paws is built on relationship-building, not instant dog care. Every dog-sharing relationship moves through the Pup-Sharing Journey, where you and your potential Pup Pal get to know one another through real-life interactions before sharing responsibility.

Take as many group walks as you need before progressing to solo walks. Move forward only when everyone—including your dog—feels comfortable and confident.`,
      },
      {
        question: "Can I leave my dog with someone the first time we meet?",
        answer: `No.

Your first meeting should always be a group walk. Use this time to get to know one another, answer questions, observe your dog's comfort level, and watch the other person interact with your dog before considering a solo walk.`,
      },
      {
        question: "Where should we meet?",
        answer: `Choose a familiar public place where your dog feels comfortable, such as your regular walking route, a neighborhood park, or another dog-friendly location.

During your group walk, we encourage you to:

• Talk about your goals for dog-sharing.
• Introduce your dog's routines and personality.
• Demonstrate any commands or handling techniques.
• Allow the other person to practice holding the leash while you observe.`,
      },
      {
        question: "What information should I share about my dog?",
        answer: `Share as much as possible.

Your Pup Playbook should include your dog's routines, personality, commands, medical needs, walking preferences, triggers, fears, and anything else that helps someone safely care for your dog.

Honesty leads to better matches and safer dog-sharing.`,
      },
      {
        question: "Can someone else let my dog off leash?",
        answer: `Only if you're comfortable with it.

Unless you've specifically agreed otherwise, we recommend that shared dogs remain on leash outside of securely enclosed areas.

Remember, someone caring for your dog doesn't know them the way you do. Set clear expectations for when, where, and if your dog may ever be off leash.`,
      },
      {
        question: "Should I tip my Pup Pal?",
        answer: `That's entirely up to you.

Social Paws is built around relationships, not transactions. While many members enjoy showing appreciation with treats, small gifts, or kind gestures, there is never an expectation to tip.

The greatest reward is building a trusted relationship that benefits both humans and dogs.`,
      },
      {
        question: "What vaccinations are required?",
        answer: `To participate in Social Paws, dogs should be current on all vaccinations required by local laws and our Community Guidelines.

We recommend maintaining vaccinations commonly required in social settings, including:

• Rabies
• DA2PP (Distemper/Parvo combination)
• Bordetella

Keeping vaccinations current helps create a healthier and safer community for everyone.`,
      },
      {
        question: "Do you have breed restrictions?",
        answer: `No. We welcome dogs of every breed.

What matters most is honest communication. Every dog has unique needs, personality traits, and behaviors, and it's the Pup Pawrent's responsibility to communicate those openly through their profile, Pup Playbook, and conversations with potential dog-sharing partners.`,
      },
      {
        question: `What if I think my dog wasn't treated appropriately?`,
        answer: `Start by having an open conversation with the other member to better understand what happened.

If you believe someone acted dishonestly, violated our Community Guidelines, or placed your dog at risk, please leave an honest review and report the profile so our team can investigate.

The safety and wellbeing of dogs always comes first.`,
      },
    ],
  },
  {
    title: "Team Social FAQs",
    subtopics: [
      {
        question:
          "Do I have to meet the Pup Pawrent before caring for their dog?",
        answer: `Yes. In fact, it's required.

Every dog-sharing relationship begins with the Pup-Sharing Journey. Meet as many times as you'd like through group walks before progressing to solo walks. Use these walks to get to know the Pup Pawrent, build trust, learn about the dog's personality, and gain confidence handling the dog in different situations.

Move forward only when everyone—including the dog—feels comfortable and excited to do so.`,
      },
      {
        question: "What should the Pup Pawrent provide?",
        answer: `The Pup Pawrent is responsible for providing everything needed for their dog's care, including items like a leash, harness, food, medications, toys, treats, or anything specific to the activity you've planned.

When in doubt, simply ask. Good communication makes for great dog-sharing.`,
      },
      {
        question: "Are the dogs vaccinated?",
        answer: `Yes. We require dogs on Social Paws to be current on the vaccinations required by local laws and our Community Guidelines.

If you have questions about a dog's vaccination history or health, we encourage you to discuss them with the Pup Pawrent before moving forward.`,
      },
      {
        question: "Can I let the dog off leash?",
        answer: `Only if the Pup Pawrent has specifically given permission.

Unless instructed otherwise, shared dogs should remain on leash outside of securely enclosed areas.

Always follow the care guidelines provided in the dog's Pup Playbook.`,
      },
      {
        question: "Where can I take the dog?",
        answer: `Always ask first.

Every Pup Pawrent has different comfort levels and care preferences. Before taking a dog on a hike, introducing them to other animals, visiting new places, offering new foods, or making changes to their routine, check with the Pup Pawrent.

When in doubt, ask. If you don't receive an answer, don't assume.`,
      },
      {
        question: "What if I think a dog is being neglected?",
        answer: `If you're concerned about a dog's wellbeing, start by having a respectful conversation with the Pup Pawrent. There may be information you're unaware of.

If you believe a dog is being neglected, abused, or placed at risk, please report the profile so our team can review the situation.

Protecting the wellbeing of dogs is one of our highest priorities.`,
      },
    ],
  },
];
